import { defineComponent as _defineComponent } from 'vue'
import { onBeforeMount, onMounted, ref } from 'vue';

import { Heading, FilterList } from '@warrenbrasil/nebraska-web';
import { AppliedAllocation, PlannedAllocation } from './components';

enum EAllocationOptions {
  APPLIED = 'applied',
  PLANNED = 'planned'
}

interface Props {
  portfolioId: string;
  hasPositions: boolean;
  isCustom: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Allocation',
  props: {
    portfolioId: null,
    hasPositions: { type: Boolean },
    isCustom: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  portfolioId: string;
  hasPositions: boolean;
  isCustom: boolean;
};



const selectedOption = ref(EAllocationOptions.APPLIED);
const allocationOptions = ref([
  {
    label: 'Atual (A)',
    value: EAllocationOptions.APPLIED,
    disabled: false
  }
]);

onBeforeMount(() => {
  selectedOption.value = props.hasPositions
    ? EAllocationOptions.APPLIED
    : EAllocationOptions.PLANNED;
});

onMounted(() => {
  if (!props.isCustom) {
    allocationOptions.value.push({
      label: 'Planejada (P)',
      value: EAllocationOptions.PLANNED,
      disabled: false
    });
  }
});

return { __sfc: true,EAllocationOptions, props, selectedOption, allocationOptions, Heading, FilterList, AppliedAllocation, PlannedAllocation }
}

})